'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports['default'] = void 0;
var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));
var _antd = require('antd');
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function EventItemPopover(_ref) {
    var schedulerData = _ref.schedulerData,
        eventItem = _ref.eventItem,
        title = _ref.title,
        startTime = _ref.startTime,
        endTime = _ref.endTime,
        statusColor = _ref.statusColor,
        property = _ref.property,
        location = _ref.location,
        Eligibility = _ref.Eligibility,
        Schedules = _ref.Schedules,
        assignedBy = _ref.assignedBy,
        assignedByImage = _ref.assignedByImage,
        duration = _ref.duration,
        status = _ref.status,
        subtitleGetter = _ref.subtitleGetter,
        viewEventClick = _ref.viewEventClick,
        viewEventText = _ref.viewEventText,
        viewEvent2Click = _ref.viewEvent2Click,
        viewEvent2Text = _ref.viewEvent2Text,
        shiftAssignHandler = _ref.shiftAssignHandler,
        shiftHistoryCB = _ref.shiftHistoryCB,
        loading = _ref.loading,
        eventItemPopoverTemplateResolver =
            _ref.eventItemPopoverTemplateResolver;
    var localeDayjs = schedulerData.localeDayjs,
        config = schedulerData.config;
    var start = localeDayjs(new Date(startTime));
    var end = localeDayjs(new Date(endTime));

    // checking either a user is eligible to change the status of shift from pending to approved.
    const userStr = localStorage.getItem('user') || '{}';
    let role = null;
    try {
        const parsed = JSON.parse(userStr);
        role = parsed?.userRole?.[0]?.trim()?.toLowerCase();
    } catch (e) {
        console.error('Error parsing user:', e);
    }

    const currentUserRole = role === 'admin' || role === 'manager';
    console.log('Role:', role);
    console.log(
        'logging current user role and status ===> ',
        currentUserRole,
        status,
    );

    if (eventItemPopoverTemplateResolver) {
        return eventItemPopoverTemplateResolver(
            schedulerData,
            eventItem,
            title,
            start,
            end,
            statusColor,
        );
    }
    var subtitle = subtitleGetter
        ? subtitleGetter(schedulerData, eventItem)
        : null;
    var showViewEvent =
        viewEventText &&
        viewEventClick &&
        (eventItem.clickable1 === undefined || eventItem.clickable1);
    var showViewEvent2 =
        viewEvent2Text &&
        viewEvent2Click &&
        (eventItem.clickable2 === undefined || eventItem.clickable2);
    var renderViewEvent = function renderViewEvent(text, clickHandler) {
        var marginLeft =
            arguments.length > 2 && arguments[2] !== undefined
                ? arguments[2]
                : 0;
        return /*#__PURE__*/ _react['default'].createElement(
            'button',
            {
                className: 'header2-text txt-btn-dis',
                type: 'button',
                style: {
                    color: '#108EE9',
                    cursor: 'pointer',
                    marginLeft: ''.concat(marginLeft, 'px'),
                },
                onClick: function onClick() {
                    return clickHandler(schedulerData, eventItem);
                },
            },
            text,
        );
    };
    return (
        /*#__PURE__*/ _react['default'].createElement('div', {
        style: {
            width: config.eventItemPopoverWidth,
        },
    }),
        /*#__PURE__*/ _react['default'].createElement(
        _antd.Row,
        {
            type: 'flex',
            style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                justifyContent: 'center',
                width: '100%',
            },
            align: 'middle',
        },
        //  config.eventItemPopoverShowColor && /*#__PURE__*/_react["default"].createElement(_antd.Col, {
        //   span: 2
        // },
        //  /*#__PURE__*/_react["default"].createElement("div", {
        //   className: "status-dot",
        //   style: {
        //     backgroundColor: statusColor
        //   }
        // })
        // ),
        // /*#__PURE__*/_react["default"].createElement(_antd.Col, {
        //   span: 22,
        //   className: "overflow-text"
        // },
        // /*#__PURE__*/_react["default"].createElement("span", {
        //   className: "header2-text",
        //   title: title
        // }, title))
        // ),

        // property Name ===================================================
        _react['default'].createElement(
            _antd.Col,
            {
                span: 24,
                className:
                    'help-text flex items-start flex-col justify-start w-full',
                style: { paddingRight: '15px' },
            },

            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: { fontSize: '12px', fontWeight: '500' },
                },
                'Location Name',
            ),
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: {
                        fontSize: '14px',
                        color: 'black',
                        fontWeight: '500',
                    },
                },
                property,
            ),
            _react['default'].createElement('hr', {
                className: 'help-text my-1',
                style: {
                    height: '0.4px',
                    width: '100%',
                    backgroundColor: '#FAFAFB',
                    opacity: 0.6,
                },
            }),
        ),

        // location =========================================================
        _react['default'].createElement(
            _antd.Col,
            {
                span: 24,
                className:
                    'help-text flex items-start flex-col justify-start w-full',
                style: {},
            },
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: { fontSize: '12px', fontWeight: '500' },
                },
                'Location',
            ),
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: {
                        fontSize: '14px',
                        color: 'black',
                        fontWeight: '500',
                    },
                },
                location,
            ),
            _react['default'].createElement('hr', {
                className: 'help-text my-1',
                style: {
                    height: '0.4px',
                    width: '100%',
                    backgroundColor: '#FAFAFB',
                    opacity: 0.6,
                },
            }),
        ),

        // Eligibility ====================================================
        _react['default'].createElement(
            _antd.Col,
            {
                span: 24,
                className:
                    'help-text flex items-start flex-col justify-start w-full',
                style: {},
            },

            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: { fontSize: '12px', fontWeight: '500' },
                },
                'Eligibility',
            ),
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: {
                        fontSize: '14px',
                        color: 'black',
                        fontWeight: '500',
                    },
                },
                Eligibility,
            ),
            _react['default'].createElement('hr', {
                className: 'help-text my-1',
                style: {
                    height: '0.4px',
                    width: '100%',
                    backgroundColor: '#FAFAFB',
                    opacity: 0.6,
                },
            }),
        ),

        // Schedules ===================================================
        _react['default'].createElement(
            _antd.Col,
            {
                span: 24,
                className:
                    'help-text flex items-start flex-col justify-start w-full',
                style: {},
            },
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: { fontSize: '12px', fontWeight: '500' },
                },
                'Schedules',
            ),
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: {
                        fontSize: '14px',
                        color: 'black',
                        fontWeight: '500',
                    },
                },
                Schedules,
            ),
            _react['default'].createElement('hr', {
                className: 'help-text my-1',
                style: {
                    height: '0.4px',
                    width: '100%',
                    backgroundColor: '#FAFAFB',
                    opacity: 0.6,
                },
            }),
        ),

        _react.default.createElement(
            _antd.Col,
            {
                span: 24,
                className:
                    'help-text flex items-start flex-col justify-start w-full',
                style: {},
            },

            // Label
            _react.default.createElement(
                'span',
                {
                    className: 'help-text',
                    style: { fontSize: '12px', fontWeight: '500' },
                },
                'Assigned By',
            ),

            // 👇 Image + Text inline row
            _react.default.createElement(
                'div',
                {
                    style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: '8px',
                        marginTop: '4px',
                    },
                },
                // Image
                _react.default.createElement('img', {
                    src: assignedByImage,
                    style: {
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                    },
                }),

                // Text next to image
                _react.default.createElement(
                    'span',
                    {
                        className: 'help-text',
                        style: {
                            fontSize: '14px',
                            color: 'black',
                            fontWeight: '500',
                        },
                    },
                    assignedBy,
                ),
            ),

            // Divider
            _react.default.createElement('hr', {
                className: 'help-text my-1',
                style: {
                    height: '0.4px',
                    width: '100%',
                    backgroundColor: '#FAFAFB',
                    opacity: 0.6,
                },
            }),
        ),

        // duration ============================================================
        _react['default'].createElement(
            _antd.Col,
            {
                span: 24,
                className:
                    'help-text flex items-start flex-col justify-start w-full',
                style: {},
            },
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: { fontSize: '12px', fontWeight: '500' },
                },
                'Duration',
            ),
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: {
                        fontSize: '14px',
                        color: 'black',
                        fontWeight: '500',
                    },
                },
                duration,
            ),
            _react['default'].createElement('hr', {
                className: 'help-text my-1',
                style: {
                    height: '0.4px',
                    width: '100%',
                    backgroundColor: '#FAFAFB',
                    opacity: 0.6,
                },
            }),
        ),

        _react['default'].createElement(
            _antd.Col,

            {
                className:
                    'help-text flex items-center flex-row justify-between w-full',
                style: {},
            },
            _react['default'].createElement(
                'span',
                {
                    className: 'help-text',
                    style: {
                        fontSize: '12px',
                        color: 'green',
                        fontWeight: '400',
                    },
                },
                status,
            ),
            currentUserRole &&
            status == 'pending' &&
            _react['default'].createElement(
                'button',
                {
                    className:
                        'help-text bg-green-300 px-2 py-1 font-bold text-md rounded-sm',
                    style: { color: 'white' },
                    onClick: () => shiftAssignHandler(eventItem),
                },
                loading ? 'Approving...' : 'Approved',
            ),
            _react['default'].createElement(
                'button',
                {
                    className:
                        'help-text bg-black px-2 py-1 font-bold text-md rounded-sm',
                    style: { color: 'white' },
                    onClick: () => shiftHistoryCB(eventItem),
                },
                'History',
            ),
        ),
        // _react["default"].createElement(
        //   "span",
        //   { className: 'help-text', style: { fontSize: '12px', color: 'green', fontWeight: '400' } },
        //   "Confirmed"

        // )

        //   _react["default"].createElement(
        //     'div',
        //     { className: 'help-text', style: { marginLeft: '8px' } },
        //     'Location Name'
        //   ),
        //   _react["default"].createElement(
        //     'div',
        //     { className: 'help-text', style: { marginLeft: '8px', fontSize: '16px', color: 'black', fontWeight: '600' } },
        //     'propertyName'
        //   ),
        //   _react["default"].createElement(
        //     'hr',
        //     { className: 'help-text', style: { marginLeft: '8px', height: '1px', border: 'none', backgroundColor: '#DEDEDE' } },

        //   ),

        //   subtitle && /*#__PURE__*/_react["default"].createElement(_antd.Row, {
        //     type: "flex",
        //     align: "middle"
        //   },

        // /*#__PURE__*/_react["default"].createElement(_antd.Col, {
        //     span: 2
        //   },
        // /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_antd.Col, {
        //     span: 22,
        //     className: "overflow-text"
        //   },
        //  /*#__PURE__*/_react["default"].createElement("span", {
        //     className: "header2-text",
        //     title: subtitle
        //   }, subtitle))),
        //  /*#__PURE__*/_react["default"].createElement(_antd.Row, {
        //     type: "flex",
        //     align: "middle"
        //   }, /*#__PURE__*/_react["default"].createElement(_antd.Col, {
        //     span: 2
        //   }, /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_antd.Col, {
        //     span: 22
        //   }, /*#__PURE__ START DATE */_react["default"].createElement("span", {
        //     className: "header1-text"
        //   }, start.format('HH:mm')), config.eventItemPopoverDateFormat && /*#__PURE__*/_react["default"].createElement("span", {
        //     className: "help-text",
        //     style: {
        //       marginLeft: '8px'
        //     }
        //   }, start.format(config.eventItemPopoverDateFormat)), /*#__PURE__*/_react["default"].createElement("span", {
        //     className: "header2-text",
        //     style: {
        //       marginLeft: '8px'
        //     }
        //   }, "-"), /*#__PURE__ END DATE */_react["default"].createElement("span", {
        //     className: "header1-text",
        //     style: {
        //       marginLeft: '8px'
        //     }
        //   }, end.format('HH:mm')), config.eventItemPopoverDateFormat && /*#__PURE__*/_react["default"].createElement("span", {
        //     className: "help-text",
        //     style: {
        //       marginLeft: '8px'
        //     }
        //   }, end.format(config.eventItemPopoverDateFormat)))), (showViewEvent || showViewEvent2) && /*#__PURE__*/_react["default"].createElement(_antd.Row, {
        //     type: "flex",
        //     align: "middle"
        //   }, /*#__PURE__*/_react["default"].createElement(_antd.Col, {
        //     span: 2
        //   }, /*#__PURE__*/_react["default"].createElement("div", null)), /*#__PURE__*/_react["default"].createElement(_antd.Col, {
        //     span: 22
        // },
        // showViewEvent && renderViewEvent(viewEventText, viewEventClick), showViewEvent2 && renderViewEvent(viewEvent2Text, viewEvent2Click, 16))
        // )
    )
    );
}
EventItemPopover.propTypes = {
    schedulerData: _propTypes['default'].object.isRequired,
    eventItem: _propTypes['default'].object.isRequired,
    title: _propTypes['default'].string.isRequired,
    startTime: _propTypes['default'].string.isRequired,
    endTime: _propTypes['default'].string.isRequired,
    statusColor: _propTypes['default'].string.isRequired,
    subtitleGetter: _propTypes['default'].func,
    viewEventClick: _propTypes['default'].func,
    viewEventText: _propTypes['default'].string,
    viewEvent2Click: _propTypes['default'].func,
    viewEvent2Text: _propTypes['default'].string,
    eventItemPopoverTemplateResolver: _propTypes['default'].func,
    shiftAssignHandler: _propTypes['default'].func,
    shiftHistoryCB: _propTypes['default'].func,
    loading: _propTypes['default'],
};
var _default = (exports['default'] = EventItemPopover);
